import axios from "axios";

const URL = process.env.REACT_APP_USER_API;

export async function getUnblockSerialNo(payload) {
  console.log("inside getUnblockSerialNo");
  let url = URL + "/getunblockSerialNo";
  let response = await axios.post(url,payload);
  console.log("getUnblockSerialNo response", response.data);
  return response.data;
}
export async function getActiveVendors(){
  let url = URL + "/activeVendors";
  let response = await axios.get(url);
  return response.data;
}

export async function deleteUnblockSerialNumber(payload) {
  let url = URL + "/deleteunblockSerialNo";
  let response = await axios.post(url, payload);
  return response.data;
}